<template>
  <div style="display: flex;justify-content: space-between">
    <el-input :value="defaultValue" style="width:60px;margin-right: 5px;" :disabled="true" />
    <cargo-advance-select
      :select-type="TYPE_NAMES.basic_data_Airport"
      :default-value="defaultValue"
      v-bind="$attrs"
      style="flex:1"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'AeBasicDestinationPortCode',
  components: { cargoAdvanceSelect },
  props: {
    defaultValue: { type: String, default: '' }
  },
  data() {
    return {
      TYPE_NAMES
    }
  }
}
</script>
